enum EPriceListRoutePath {
  OVERVIEW = '/pricelist',
  FORM = '/pricelist/form',
}

export default EPriceListRoutePath;
